module.exports = __webpack_public_path__ + "static/media/fiets.71c00641.png";